import translations from './translations'
import { GLOBAL_ERROR_DEFAULT } from './../models/ErrorCode'

translations.add('pt', {
    errors: {
        [GLOBAL_ERROR_DEFAULT]: 'Ocorreu um erro.'
    }
})
